import React, { useEffect, useRef } from "react";
import "./homeText.css";
import { gsap } from "gsap";
// import video from "./images/textVid.mp4";
export default function HomeText() {
  return (
    <div className="homeText-main">
      <div className="homeText-text">
        <p>
          Fie că vrei să faci primul pas în universul bijuteriilor exclusiviste
          sau dorești să adaugi noi piese în colecția ta, fii gata să descoperi
          toate fațetele frumosului.
          <br className="br-portrait " />
          <br className="br-portrait " /> Imaginația artizanilor bijutieri a
          creat <br className=" br-portrait" />
          <b>cinci forme sublime</b>, ale diamantului, transpuse în piese unice,
          cu un design <b>încântător</b>.
        </p>
        <br />
        <p className="homeText-second">
          Bijuterii fine care îți îmbracă orice ținută în eleganță, în fiecare
          zi.
        </p>
      </div>
    </div>
  );
}
